(function(){
  // Menu mobilne: zamknij po kliknięciu w link.
  [].forEach.call(document.querySelectorAll('.mnav a'),function(a){a.addEventListener('click',function(){a.closest('details').open=false;});});

  var dataEl=document.getElementById('bx-media');
  if(!dataEl)return;
  var media=[];try{media=JSON.parse(dataEl.textContent)||[];}catch(_){}

  // Zdjęcia produktu mają alt „Kolor | Ujęcie”. „Wymiary | …” dołączamy do każdego koloru.
  var byColor={},shared=[];
  media.forEach(function(m){
    var parts=String(m.alt||'').split('|'),key=(parts[0]||'').trim(),label=(parts[1]||'').trim();
    var it={src:m.src,t:m.t,label:label};
    if(key.toLowerCase()==='wymiary'){it.label='Wymiary · '+label;shared.push(it);}
    else{(byColor[key]=byColor[key]||[]).push(it);}
  });
  function imgsFor(name){return (byColor[name]||[]).concat(shared);}

  var sws=[].slice.call(document.querySelectorAll('.sw[data-variant]'));
  var active=document.querySelector('.sw.active')||sws[0];
  var color=active?active.getAttribute('data-name'):Object.keys(byColor)[0],idx=0;

  var $=function(id){return document.getElementById(id);};
  var mainimg=$('mainimg'),idxEl=$('idx'),viewtag=$('viewtag'),thumbs=$('thumbs'),vname=$('vname'),vbadge=$('vbadge'),vdesc=$('vdesc');
  var lb=$('lb'),lbstage=$('lbstage'),lbimg=$('lbimg'),lbcap=$('lbcap'),lbthumbs=$('lbthumbs');
  var pad=function(n){return String(n).padStart(2,'0');};

  function renderThumbs(box,list,inLB){
    box.innerHTML='';
    list.forEach(function(it,i){
      var t=document.createElement('div');t.className='thumb'+(i===idx?' active':'');
      var im=document.createElement('img');im.src=it.t||it.src;im.alt=color+' '+it.label;im.loading='lazy';t.appendChild(im);
      if(!inLB){var l=document.createElement('span');l.className='tlabel';l.textContent=it.label;t.appendChild(l);}
      t.addEventListener('click',function(e){e.stopPropagation();idx=i;resetZoom();render();});
      box.appendChild(t);
    });
  }
  function render(){
    var list=imgsFor(color);if(!list.length)return;
    if(idx>=list.length)idx=0;
    var im=list[idx];
    mainimg.src=im.src;mainimg.alt='Nerka baxly '+color+' — '+im.label;
    idxEl.textContent='Nº'+pad(idx+1)+' / '+pad(list.length);viewtag.textContent=im.label;
    renderThumbs(thumbs,list,false);
    if(lb&&lb.classList.contains('open'))renderLB();
  }
  function step(d){var n=imgsFor(color).length;idx=(idx+d+n)%n;render();}

  function selectVariant(sw,byUser){
    sws.forEach(function(x){x.classList.remove('active');});
    sw.classList.add('active');
    color=sw.getAttribute('data-name');idx=0;
    vname.firstChild.textContent=color+' ';
    var badge=sw.getAttribute('data-badge');
    if(badge){vbadge.style.display='';vbadge.textContent=badge;}else{vbadge.style.display='none';}
    vdesc.textContent=sw.getAttribute('data-desc')||'';
    var input=$('bx-variant-id'),btn=$('bx-buy-btn');
    if(input){
      input.value=sw.getAttribute('data-variant');
      var ok=sw.getAttribute('data-available')==='true';
      if(btn){btn.disabled=!ok;btn.textContent=ok?'Kup teraz':'Wyprzedane';}
    }
    if(byUser&&/^\/products\//.test(location.pathname)){
      var u=new URL(location.href);u.searchParams.set('variant',sw.getAttribute('data-variant'));history.replaceState(null,'',u);
    }
    render();
  }
  sws.forEach(function(s){s.addEventListener('click',function(){selectVariant(s,true);});});
  $('prev').addEventListener('click',function(e){e.stopPropagation();step(-1);});
  $('next').addEventListener('click',function(e){e.stopPropagation();step(1);});

  function renderLB(){
    var list=imgsFor(color),im=list[idx];
    lbimg.src=im.src;lbimg.alt=color+' '+im.label;
    lbcap.textContent=color+' · '+im.label+' — kliknij, aby '+(lbstage.classList.contains('zoomed')?'oddalić':'przybliżyć');
    renderThumbs(lbthumbs,list,true);
  }
  function openLB(){lb.classList.add('open');lb.setAttribute('aria-hidden','false');document.body.style.overflow='hidden';resetZoom();renderLB();}
  function closeLB(){lb.classList.remove('open');lb.setAttribute('aria-hidden','true');document.body.style.overflow='';resetZoom();}
  function resetZoom(){if(!lbstage)return;lbstage.classList.remove('zoomed');lbimg.style.transform='scale(1)';lbimg.style.transformOrigin='center center';}
  if(lb){
    $('stage').addEventListener('click',openLB);
    $('lbclose').addEventListener('click',closeLB);
    lb.addEventListener('click',function(e){if(e.target===lb)closeLB();});
    $('lbprev').addEventListener('click',function(e){e.stopPropagation();resetZoom();step(-1);});
    $('lbnext').addEventListener('click',function(e){e.stopPropagation();resetZoom();step(1);});
    lbstage.addEventListener('click',function(e){
      if(e.target.classList.contains('arrow'))return;
      var z=lbstage.classList.toggle('zoomed');
      lbimg.style.transform=z?'scale(2.2)':'scale(1)';if(!z)lbimg.style.transformOrigin='center center';
      lbcap.textContent=color+' · '+imgsFor(color)[idx].label+' — kliknij, aby '+(z?'oddalić':'przybliżyć');
    });
    lbstage.addEventListener('mousemove',function(e){
      if(!lbstage.classList.contains('zoomed'))return;
      var r=lbstage.getBoundingClientRect();lbimg.style.transformOrigin=(((e.clientX-r.left)/r.width)*100)+'% '+(((e.clientY-r.top)/r.height)*100)+'%';
    });
    document.addEventListener('keydown',function(e){
      if(!lb.classList.contains('open'))return;
      if(e.key==='Escape')closeLB();else if(e.key==='ArrowLeft'){resetZoom();step(-1);}else if(e.key==='ArrowRight'){resetZoom();step(1);}
    });
  }
  if(active)selectVariant(active);else render();
})();

// Dostawa: na planie Basic mapa w kasie nie działa, więc paczkomat wybiera się tu i trafia do atrybutów koszyka
// (w zamówieniu: „Dodatkowe szczegóły”). Kod punktu wpisuje się przy nadaniu w Furgonetce.
(function(){
  var form=document.getElementById('bx-product-form'),box=document.getElementById('bx-ship');
  if(!form||!box)return;
  var $=function(id){return document.getElementById(id);};
  var pointBox=$('bx-point'),pointName=$('bx-point-name'),pointBtn=$('bx-point-btn'),err=$('bx-ship-err');
  var A_MODE='Dostawa',A_CODE='Paczkomat',A_NAME='Paczkomat (adres)';
  var point=null,lib=null,sending=false;

  function mode(){var r=box.querySelector('input[name="bx-ship"]:checked');return r?r.value:'punkt';}
  function fail(msg){err.textContent=msg;err.hidden=false;}
  function show(){
    pointBox.hidden=mode()!=='punkt';
    pointName.textContent=point?point.code+' · '+point.name:'Nie wybrano paczkomatu';
    pointBtn.textContent=point?'Zmień paczkomat':'Wybierz paczkomat';
    if(point||mode()!=='punkt')err.hidden=true;
  }
  [].forEach.call(box.querySelectorAll('input[name="bx-ship"]'),function(r){r.addEventListener('change',show);});
  // Powrót z kasy przyciskiem „wstecz” odtwarza stronę z pamięci, razem z zablokowanym formularzem.
  window.addEventListener('pageshow',function(){sending=false;});

  // Wybór sprzed odświeżenia strony zostaje w koszyku.
  fetch('/cart.js').then(function(r){return r.json();}).then(function(c){
    var a=c.attributes||{};
    if(a[A_CODE])point={code:a[A_CODE],name:a[A_NAME]||''};
    if(a[A_MODE]==='Kurier')box.querySelector('input[value="kurier"]').checked=true;
    show();
  }).catch(function(){});

  function loadMap(){
    if(window.Furgonetka)return Promise.resolve();
    return lib=lib||new Promise(function(ok,no){
      var s=document.createElement('script');s.src='https://furgonetka.pl/js/dist/map/map.js';s.async=true;
      s.onload=ok;s.onerror=function(){lib=null;no();};document.head.appendChild(s);
    });
  }
  pointBtn.addEventListener('click',function(){
    loadMap().then(function(){
      new window.Furgonetka.Map({
        apiKey:box.getAttribute('data-map-key'),
        courierServices:['inpost'],
        // Polska + kraje z paczkomatami InPost International.
        countryCodesFilter:['PL','FR','BE','NL','LU','ES','PT','IT'],
        mapBounds:'pl',
        locale:'pl',
        callback:function(res){
          var p=res&&res.point;if(!p)return;
          point={code:p.code,name:p.name+(p.country_code&&p.country_code!=='PL'?' ('+p.country_code+')':'')};
          show();
        }
      }).show();
    }).catch(function(){fail('Nie udało się wczytać mapy paczkomatów. Odśwież stronę i spróbuj ponownie.');});
  });

  form.addEventListener('submit',function(e){
    e.preventDefault();
    if(sending)return;
    var m=mode();
    if(m==='punkt'&&!point){
      fail('Wybierz paczkomat, żeby przejść do kasy.');
      box.scrollIntoView({behavior:'smooth',block:'center'});
      return;
    }
    var a={};
    a[A_MODE]=m==='punkt'?'Paczkomat InPost':'Kurier';
    a[A_CODE]=m==='punkt'?point.code:'';
    a[A_NAME]=m==='punkt'?point.name:'';
    sending=true;
    // Błąd zapisu nie blokuje zakupu: punkt ustalimy wtedy z klientem.
    fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:a})})
      .catch(function(){}).then(function(){form.submit();});
  });
})();
